import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Input,
  Label,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface BasicInputDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (value: string) => void;
  title: string;
  label: string;
  initialValue?: string;
}

const BasicInputDialog: React.FC<BasicInputDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  title,
  label,
  initialValue = '',
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (isOpen) {
      setValue(initialValue);
    }
  }, [isOpen, initialValue]);

  const handleSave = () => {
    if (value.trim()) {
      onSave(value.trim());
      setValue('');
    }
  };

  const handleClose = () => {
    setValue('');
    onClose();
  };

  return (
    <Dialog modalType='alert' open={isOpen} onOpenChange={(_, data) => !data.open && handleClose()}>
      <DialogSurface className="max-w-[500px]">
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                shape="circular"
                aria-label="close"
                icon={<DismissRegular />}
                onClick={handleClose}
              />
            }
          >
            {title}
          </DialogTitle>
          <DialogContent>
            <div className="space-y-2">
              <Label htmlFor="input-field">{label}</Label>
              <Input
                id="input-field"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="w-full"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSave();
                  }
                }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={handleClose}>
              Avbryt
            </Button>
            <Button appearance="primary" onClick={handleSave} disabled={!value.trim()}>
              OK
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default BasicInputDialog;
